import {defineNuxtPlugin} from '#imports';

// Script-Quellen, die in CMS-Inhalten (v-execute-script) bei clientseitigem
// Seitenwechsel immer neu ausgeführt werden – ohne dass jede CMS-Route dafür
// "options.executeScriptSrc" gesetzt haben muss. Werte aus der Route werden
// weiterhin zusätzlich berücksichtigt.
const DEFAULT_EXECUTE_SCRIPT_SRC = ['https://www.outdooractive.com'];

function getExecuteScriptSrc(binding) {
	const routeSrc = binding.instance?.options?.executeScriptSrc;
	const routeSrcList = routeSrc ? [].concat(routeSrc) : [];
	return [...new Set([...DEFAULT_EXECUTE_SCRIPT_SRC, ...routeSrcList])];
}

// Überschreibt die Hooks der Direktive aus @webcontact/nuxt-kommunen
// (runtime/plugins/nuxt-kommunen.mjs). Das Nachladen der Scripts übernimmt
// weiterhin deren "page:loading:end"-Hook anhand von el.executeScriptSrc.
export default defineNuxtPlugin(nuxtApp => {
	const directive = nuxtApp.vueApp.directive('execute-script');
	if (!directive) return;

	directive.mounted = (el, binding) => {
		el.classList.add('js-execute-script');
		el.executeScriptSrc = getExecuteScriptSrc(binding);
	};

	// Beim Verlassen der Seite die in den Body nachgeladenen Scripts entfernen,
	// damit sie beim nächsten Besuch erneut ausgeführt werden.
	directive.unmounted = (_el, binding) => {
		getExecuteScriptSrc(binding).forEach(src => {
			document.body
				.querySelectorAll(`script[src^="${src}"]`)
				.forEach(script => {
					if (!script.closest('.js-execute-script')) script.remove();
				});
		});
	};
});
